import { formNeedsVariables } from '../../pages/project/crfBulkActions';

/**
 * A form waits in the bulk run's queue with generatingVars false, so the user can open it meanwhile and
 * the open-form effect generates it. When the run's turn for that form comes, look at the form AS IT IS NOW:
 * if it already has variables, or something is generating it, skip it - generating again would overwrite
 * that result and any edits made to it.
 *
 * Pure: no React, no Firebase.
 */
export function shouldSkipQueuedForm(
  current: { variables?: unknown[] | null; generatingVars?: boolean } | undefined,
): boolean {
  if (!current) return true; // removed while waiting
  if (current.generatingVars) return true;
  return !formNeedsVariables(current as Parameters<typeof formNeedsVariables>[0]);
}
